import Api from '../api';
import { t } from 'i18next';

export default class ChartApi extends Api {
  getCustomDashboardConfigs = async () => {
    try {
      const apiData = await this.get(`chart_query/`);
      return apiData;
    } catch (error) {
      return {
        hasError: true,
        error: error,
        customMessage: t('GRAAS_FAIL_TO_LOAD_DATA_GRAAS')
      };
    }
  };

  getCustomDashboardList = async props => {
    try {
      const apiData = await this.get(`/custom-dashboard/?trace_id=${props?.trace_id}&path=${props?.path}`);
      return apiData;
    } catch (error) {
      return {
        hasError: true,
        error: error,
        customMessage: t('GRAAS_FAIL_TO_LOAD_DATA_GRAAS')
      };
    }
  };

  onCreateCustomDashboard = async payload => {
    try {
      const apiData = await this.post(`/custom-dashboard/`, [payload]);
      return apiData;
    } catch (error) {
      return {
        hasError: true,
        error: error,
        customMessage: 'Fail to create dashboard'
      };
    }
  };

  getMetricDimensionMapping = async (loadNewWarehouse, channel) => {
    try {
      const apiData = await this.get(
        `/metricDimensions?loadNewWarehouse=${loadNewWarehouse}${channel ? `&channel=${channel}` : ''}`
      );
      return apiData;
    } catch (error) {
      return {
        hasError: true,
        error: error,
        customMessage: t('GRAAS_FAIL_TO_LOAD_DATA_GRAAS')
      };
    }
  };

  onPublishChart = async payload => {
    const { dashboard_id, ...rest } = payload;
    try {
      const apiData = await this.put(`/custom-dashboard/${dashboard_id}`, rest);
      return apiData;
    } catch (error) {
      return {
        hasError: true,
        error: error,
        customMessage: 'Fail to publish chart'
      };
    }
  };

  getCustomDashboardDetails = async id => {
    try {
      const apiData = await this.get(`/custom-dashboard/?dashboardId=${id}&type=order_status`);
      return apiData;
    } catch (error) {
      return {
        hasError: true,
        error: error,
        customMessage: 'Fail to get dashboard details'
      };
    }
  };

  onUpdateCustomDashboard = async (payload, dashboard_id) => {
    try {
      const apiData = await this.patch(`/custom-dashboard/${dashboard_id}`, payload);
      return apiData;
    } catch (error) {
      return {
        hasError: true,
        error: error,
        customMessage: 'Fail to publish chart'
      };
    }
  };

  onCreateChannelSpecificDashboard = async payload => {
    try {
      const apiData = await this.post(`/custom-dashboard/templates`, payload);
      return apiData;
    } catch (error) {
      return {
        hasError: true,
        error: error,
        customMessage: 'Fail to create dashboard'
      };
    }
  };
}
